import React from 'react';
import Header from './components/layout/Header';
import Hero from './components/home/Hero';
import Footer from './components/layout/Footer';
import './styles/globals.css';

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Hero />
      </main>
      <Footer />
    </div>
  );
}

export default App;
